import { IconBack, TextLink } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './BackLink.module.scss';

const cx = classnames.bind(styles);

export type BackLinkProps = {
  href: string;
  text: string;
};

export const BackLink: FC<BackLinkProps> = memo(({ href, text }) => {
  return (
    <TextLink href={href} prefixIcon={<IconBack />} className={cx('back-link')}>
      {text}
    </TextLink>
  );
});

BackLink.displayName = 'BackLink';
